// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"424":"64010970","827":"34a722af","945":"8fcf071c"}[chunkId] + ".js";
};